module.exports = __webpack_public_path__ + "media/src/images/balloons/HomeBanner-yellow-e49212c0c586a020c338ca0225628274.jpg";